import React from 'react';
import FindYourProgram from '../../../components/templates/homePageSections/findYourProgram/FindYourProgram';
import Home from '../../../components/templates/homePageSections/home/Home';
import Latest from '../../../components/templates/homePageSections/latest/Latest';
import Degrees from '../../../components/templates/homePageSections/degrees/Degrees';
import CampusLife from '../../../components/templates/homePageSections/campusLife/CampusLife';
import AboutTheAcademy from '../../../components/templates/homePageSections/aboutTheAcademy/AboutTheAcademy';
import UniversalMap from '../../../components/templates/homePageSections/universalMap/UniversalMap';
// import Testimonials from '../../../components/templates/homePageSections/testimonials/Testimonial';
import Footer from '../../../components/templates/homePageSections/footer/Footer';
import TestimonialsSection from '../../../components/templates/homePageSections/testimonials-new/TestimonialsSection';
import AcademyInNumber from '../../../components/templates/homePageSections/academyInNumber/AcademyInNumber';

const sectionComponents = [
  Home,
  Latest,
  FindYourProgram,
  Degrees,
  CampusLife,
  AboutTheAcademy,
  UniversalMap,
  AcademyInNumber,
  TestimonialsSection,
  Footer,
];

// this is for the url to be #home ...
export const sectionIds = [
  'home',
  'latest',
  'find-your-program',
  'degrees',
  'campus-life',
  'about-the-academy',
  'universal-map',
  'academy-in-number',
  'testimonials',
  'footer',
];
export default sectionComponents;
